export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Offres"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mes transactions"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mes annonces"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Transactions"])}
}